// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"611":"ae486207","979":"70eefa86","982":"c143b522"}[chunkId] + ".chunk.css";
};